/**
 * Mobile Video Autoplay
 * Automatically enables autoplay + mute for videos on mobile devices
 * Modern browsers require muted attribute for autoplay to work
 */

(function() {
  // Detect if device is mobile
  const isMobileDevice = () => {
    // Check user agent for mobile devices
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true;
    }
    // Check for touch capability and small screen
    if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
      return true;
    }
    if (window.innerWidth <= 768) {
      return true;
    }
    return false;
  };

  const loadDeferredSources = (video) => {
    if (video.dataset.nwVideoLoaded === 'true') return;

    let hasDeferredSource = false;
    video.querySelectorAll('source[data-src]').forEach(source => {
      if (!source.getAttribute('src')) {
        source.setAttribute('src', source.dataset.src);
        hasDeferredSource = true;
      }
    });

    if (video.dataset.src && !video.getAttribute('src')) {
      video.setAttribute('src', video.dataset.src);
      hasDeferredSource = true;
    }

    video.dataset.nwVideoLoaded = 'true';

    if (hasDeferredSource) {
      video.load();
    }
  };

  const enableVideo = (video) => {
    loadDeferredSources(video);

    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.muted = true;

    if (video.paused) {
      video.play().catch(err => {
        console.warn('Video autoplay failed:', err);
      });
    }

    video.addEventListener('canplay', function() {
      if (video.paused) {
        video.play().catch(err => {
          console.warn('Video autoplay on canplay failed:', err);
        });
      }
    }, { once: true });
  };

  // Enable autoplay on videos marked for mobile autoplay when they are close to view.
  const enableMobileVideoAutoplay = () => {
    if (!isMobileDevice()) return;

    // Handle videos with data-mobile-autoplay attribute
    document.querySelectorAll('video[data-mobile-autoplay="true"]').forEach(video => {
      if (video.dataset.nwAutoplayObserved === 'true') return;
      video.dataset.nwAutoplayObserved = 'true';

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            enableVideo(video);
            observer.unobserve(video);
          });
        }, { rootMargin: '200px 0px' });

        observer.observe(video);
      } else {
        enableVideo(video);
      }
    });

    // Handle deferred-media elements with autoplay attribute
    document.querySelectorAll('deferred-media[autoplay] video').forEach(video => {
      video.setAttribute('muted', '');
      video.muted = true;
      
      if (video.paused) {
        video.play().catch(err => {
          console.warn('Deferred video autoplay failed:', err);
        });
      }
    });
  };

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableMobileVideoAutoplay);
  } else {
    enableMobileVideoAutoplay();
  }

  // Also run after a short delay to catch dynamically loaded videos
  setTimeout(enableMobileVideoAutoplay, 1000);

  // Run on Shopify theme editor updates
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', enableMobileVideoAutoplay);
  }
})();
